<div [formGroup]="formGroup" class="pure-g">
  <!-- Mode -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    @if (isEditMode) {
      <mc-input ngDefaultControl label="Mode" formControlName="mode" [disabled]="true" fit="small" required> </mc-input>
    } @else {
      <mc-select
        ngDefaultControl
        label="Mode"
        formControlName="mode"
        [attr.invalid]="isControlInErrorState(formGroup.controls['mode'])"
        fit="small"
        placeholder="Select a mode"
        required
        (optionselected)="onModeChange($event)">
        @for (mode of repairModeList; track mode.code) {
          <mc-option [value]="mode.code">{{ mode.code }} - {{ mode.description }}</mc-option>
        }
        @if (formGroup.get('mode')?.hasError('required')) {
          <span slot="errormessage">Mode is required</span>
        }
      </mc-select>
    }
  </div>

  <!-- Description (only in edit mode) -->
  @if (isEditMode) {
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <mc-input ngDefaultControl label="Description" formControlName="description" [disabled]="true" fit="small"> </mc-input>
    </div>
  }

  <!-- Repair Code -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    @if (isEditMode) {
      <mc-input ngDefaultControl label="Repair Code" formControlName="repairCode" [disabled]="true" fit="small" required> </mc-input>
    } @else {
      <mc-typeahead
        ngDefaultControl
        label="Repair Code"
        formControlName="repairCode"
        [data]="repairCodeTypeaheadData"
        highlight="true"
        showlistonfocus="true"
        maxoptions="100"
        optionsheight="400px"
        placeholder="Type to search"
        [attr.invalid]="isControlInErrorState(formGroup.controls['repairCode'])"
        fit="small"
        required>
        @if (formGroup.get('repairCode')?.hasError('required')) {
          <span slot="errormessage">Repair Code is required</span>
        }
      </mc-typeahead>
    }
  </div>

  <!-- Grades Applicable -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    <mc-multi-select
      ngDefaultControl
      label="Grades applicable"
      fit="small"
      placeholder="Nothing selected"
      formControlName="gradesApplicable">
      @for (grade of gradeOptions; track grade) {
        <mc-option [value]="grade">{{ grade }}</mc-option>
      }
    </mc-multi-select>
    <span class="helper-text">Select all grades applicable to the repair code.</span>
  </div>

  <!-- Generate Grade Change -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    <mc-radio-group
      ngDefaultControl
      name="generateGradeChange"
      legend="Generate grade change"
      fit="small"
      orientation="horizontal"
      formControlName="generateGradeChange">
      <mc-radio name="generateGradeChange" value="yes" label="Yes"></mc-radio>
      <mc-radio name="generateGradeChange" value="no" label="No"></mc-radio>
    </mc-radio-group>
  </div>
</div>
